export default __webpack_public_path__ + "static/media/06__o_preview_1.9541ff73.jpg";